<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']">
    <div class="content">
        <div class="order-details">
            <div class="content p-0">
                <div class="page-header">
                    <div class="page-title">
                        <h4>Order</h4>
                        
                    </div>
                    <div class="page-btn d-flex">
                        <div class="tabs" *ngIf="userType =='CUSTOMER'">
                            <!-- <a routerLink="/orders" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }">All Orders</a> -->
                            <!-- <a routerLink="/orders/draft-order" routerLinkActive="active">Draft Order</a> -->
                        </div>
                        <!-- <a  *ngIf="accessControlService.canWrite('Common Upload')" class="btn btn-added ms-3" (click)="upload('/utility/upload',{ type: 'budget' })"> Upload Order</a> -->
                        <!-- *ngIf="accessControlService.canWrite('Budget')" -->
                        <button *ngIf="hasRole('ROLE_OPERATION') && selectedRows.length>0 && activeQuickFilter === 'HARD_POD'" 
                         class="btn btn-added" (click)="receiveHardPod()">Receive Hard POD</button>
                        <button *ngIf="hasRole('ROLE_KAM') || hasRole('ROLE_SUPERUSER')" 
                         class="btn btn-added" (click)="createFtlOrder('Add')">+ Order</button>
                        <div *ngIf="hasRole('ROLE_VENDOR')" class="col" style="padding-left: 0;">
                            <app-export-btn [selectedRows]="selectedRows" [allColumns]="columns" [fileName]="'Orders'" [exportApi]="getListExportApi"
                            [exportParams]="{ filters: filters, sortingCol: sortingCol, direction: direction }"></app-export-btn>
                        </div>                              
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <div class="table-top" style="justify-content: space-between !important;">
                            <div class="search-set">
                                <app-filter (filterChange)="onFilterChange($event)" [orderNumber]="true" [showDateFilter]="true" [lrNumber]="hasRole('ROLE_VENDOR') ? false : true" [orderType]="hasRole('ROLE_VENDOR') ? false : true" [tmsVendorOrderStatus]="hasRole('ROLE_VENDOR') ? true : false" [tmsOrderStatus]="hasRole('ROLE_VENDOR') ? false : false" [DateofPlacement]="false" [showB2bCustomer]="hasRole('ROLE_VENDOR') ? false : true" [showVendor]="false"
                                    (resetFilters)="onResetFilters()">
                                </app-filter>
                                <div *ngIf="notRole('ROLE_VENDOR')" class="quickFilter px-2">
                                    <div class="quick-filter-chips">
                                      <span
                                        *ngFor="let qf of quickFilters"
                                        class="quick-chip"
                                        [class.active]="activeQuickFilter === qf.value"
                                        (click)="onQuickFilter(qf)">
                                        <!-- <span class="chip-dot" [style.background]="qf.color"></span> -->
                                        {{ qf.label }}
                                        <span class="chip-count" *ngIf="activeQuickFilter === qf.value">{{ totalCount ?? 0 }}</span>
                                      </span>
                                    </div>
                                  </div>
                                <ng-container *ngIf="userType !=='VENDOR' && userType !=='ASSOCIATE'">
                                <!-- <ng-container *ngIf="selectedData[0]?.status == 'Draft' || selectedData[0]?.status == 'Created'">
                                <a class="btn btn-primary ml-3 mr-3" *ngIf="(selectedData?.length ?? 0) > 0" (click)="editEvent()">Edit</a>
                                </ng-container> -->
                                </ng-container>
                                <button
                                    type="button"
                                    class="btn btn-primary ml-3"
                                    *ngIf="activeQuickFilter === 'READY_FOR_VENDOR_BILLING' && (selectedData?.length ?? 0) > 0"
                                    [disabled]="selectedData?.length === 0 || !canCreateVendorBill()"
                                    [pTooltip]="!canCreateVendorBill() && (selectedData?.length ?? 0) > 0
                                    ? 'Please select orders from the same vendor.'
                                    : ''"
                                    (click)="createVendorBill()">
                                    Create Bill
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-primary ml-3"
                                    *ngIf="activeQuickFilter === 'READY_FOR_CUSTOMER_BILLING' && (selectedData?.length ?? 0) > 0"
                                    [disabled]="selectedData?.length === 0 || !canCreateCustomerBill()"
                                    [pTooltip]="!canCreateCustomerBill() && (selectedData?.length ?? 0) > 0
                                    ? 'Please select orders from the same customer.'
                                    : ''"
                                    (click)="createCustomerBill()">
                                    Create Bill
                                </button>
                                <!-- <a *ngIf="selectedData.length == 1" class="btn btn-primary ml-3 mr-3" (click)="duplicateEvent()">Duplicate</a>
                                <a *ngIf="selectedData.length > 0" class="btn btn-primary ml-3 mr-3" (click)="deleteEvent()">Delete</a> -->
                            </div>
                            <app-column-toggle [moduleName]="'Orders'" [allowedKeys]="allowedColumnKeys"></app-column-toggle>
                        </div>

                        <!-- <app-shared-table [componentName]="'orders'" [columns]="columns" [tableName]="tableName" [data]="tableLists" [dropdownOptions]="dropdownOptions"
                            (sortChange)="onSortChange($event)" (selectedRowsChange)="onSelectedRowsChange($event)" (reloadEvent)="reloadEvent($event)">
                        </app-shared-table> -->

                        <div class="card">
                            <p-table
                              [value]="tableLists"
                              [(selection)]="selectedData"
                              dataKey="id"
                              [first]="first"
                              [showCurrentPageReport]="true"
                              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                              [scrollable]="true"
                              [tableStyle]="{ width: '100%' }"
                              [resizableColumns]="true" columnResizeMode="expand" [responsiveLayout]="'scroll'"
                              (selectionChange)="onSelectedRowsChange($event)"
                              #tableRef
                            >
                              <ng-template pTemplate="header">
                                <tr>
                                  <th style="min-width: 35px">
                                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                  </th>
                                  <th pResizableColumn pSortableColumn="orderNumber" (click)="sortColumn('orderNumber', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    Order No <p-sortIcon field="orderNumber"></p-sortIcon>
                                  </th>
                                  <th pResizableColumn pSortableColumn="remarks" *ngIf="isColumnVisible('status')" (click)="sortColumn('remarks', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    <span>Status</span> <p-sortIcon field="remarks"></p-sortIcon>
                                 </th>
                                  <th pResizableColumn *ngIf="notRole('ROLE_VENDOR') && isColumnVisible('lrNumber')">
                                    LR No
                                  </th>
                                  <!-- <th *ngIf="notRole('ROLE_VENDOR')" pResizableColumn pSortableColumn="status" (click)="sortColumn('status', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    LR Number <p-sortIcon field="status"></p-sortIcon>
                                  </th> -->
                                  <th *ngIf="notRole('ROLE_VENDOR') && isColumnVisible('customerName')" pResizableColumn pSortableColumn="customerName" (click)="sortColumn('customerName', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    Customer <p-sortIcon field="customerName"></p-sortIcon>
                                  </th>
                                  <th *ngIf="hasRole('ROLE_VENDOR_BILLING_USER') && isColumnVisible('vendorName')" pResizableColumn pSortableColumn="vendorName" (click)="sortColumn('vendorName', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    Vendor <p-sortIcon field="vendorName"></p-sortIcon>
                                  </th>
                                  <th *ngIf="hasRole('ROLE_VENDOR') && isColumnVisible('accountName')" pResizableColumn pSortableColumn="accountName" (click)="sortColumn('accountName', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    Account <p-sortIcon field="accountName"></p-sortIcon>
                                  </th>
                                  <!-- <th pResizableColumn pSortableColumn="accountName" (click)="sortColumn('accountName', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    Truck Count <p-sortIcon field="accountName"></p-sortIcon>
                                  </th> -->
                                  <th pResizableColumn *ngIf="isColumnVisible('route')">
                                    Route
                                  </th>
                                  <th class="" *ngIf="isColumnVisible('vehicleRequiredAt')" pResizableColumn pSortableColumn="vehicleRequiredAt" (click)="sortColumn('vehicleRequiredAt', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    Placement Date <p-sortIcon field="vehicleRequiredAt"></p-sortIcon>
                                  </th>
                                  <th *ngIf="notRole('ROLE_VENDOR') && isColumnVisible('orderType')" pResizableColumn pSortableColumn="orderType" (click)="sortColumn('orderType', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    Type <p-sortIcon field="orderType"></p-sortIcon>
                                  </th>
                                  <th *ngIf="notRole('ROLE_VENDOR') && isColumnVisible('assignedKam')" pResizableColumn pSortableColumn="assignedKam" (click)="sortColumn('assignedKam', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    KAM <p-sortIcon field="assignedKam"></p-sortIcon>
                                  </th>
                                  <th class="" *ngIf="hasRole('ROLE_VENDOR') && isColumnVisible('procurementPrice')" pResizableColumn pSortableColumn="procurementPrice" (click)="sortColumn('procurementPrice', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    Procurement Amount <p-sortIcon field="procurementPrice"></p-sortIcon>
                                  </th>
                                  <th *ngIf="hasRole('ROLE_VENDOR') && isColumnVisible('bidAmount')" pResizableColumn pSortableColumn="bidAmount" (click)="sortColumn('bidAmount', direction == 'DESC' ? 'ASC' : 'DESC')">
                                    Last Bid <p-sortIcon field="bidAmount"></p-sortIcon>
                                  </th>
                                 <th *ngIf="isColumnVisible('summary') && notRole('ROLE_VENDOR')" pResizableColumn>Summary</th>
                                  <th pResizableColumn style="width: 120px;">Action</th>
                                </tr>
                              </ng-template>
                          
                              <ng-template pTemplate="body" let-item>
                                <tr>
                                  <td>
                                    <p-tableCheckbox [value]="item"></p-tableCheckbox>
                                  </td>
                                  <td>
                                    <a class="active" (click)="viewOrderHistory(item.id)">{{ item.orderNumber }}</a>
                                  </td>
                                  <td *ngIf="isColumnVisible('status')">
                                    <span
                                      class="order-status-pill"
                                      [ngClass]="getOrderStatusClass(item?.status)">
                                      {{ getOrderStatusLabel(item?.status) }}
                                    </span>
                                  </td>
                                  <td *ngIf="notRole('ROLE_VENDOR') && isColumnVisible('lrNumber')">{{ getLrNumbers(item?.tripLrInfo) }}</td>
                                  <!-- <td *ngIf="notRole('ROLE_VENDOR')">{{ item?.lrNumber }}</td> -->
                                  <td *ngIf="notRole('ROLE_VENDOR') && isColumnVisible('customerName')">{{ item?.customerName }}</td>
                                  <td *ngIf="hasRole('ROLE_VENDOR_BILLING_USER') && isColumnVisible('vendorName')">{{ item?.vendorName }}</td>
                                  <td *ngIf="hasRole('ROLE_VENDOR') && isColumnVisible('accountName')">{{ item?.accountName }}</td>
                                  <!-- <td>{{ item?.numberOfVehicle }}</td> -->
                                  <td *ngIf="isColumnVisible('route')">{{ item?.route }}</td>
                                  <td *ngIf="isColumnVisible('vehicleRequiredAt')">{{ item?.vehicleRequiredAt | CustomDatePipe: 'D-M-YYYY' }}</td>
                                  <td *ngIf="notRole('ROLE_VENDOR') && isColumnVisible('orderType')">{{ item?.orderType }}</td>
                                  <td *ngIf="notRole('ROLE_VENDOR') && isColumnVisible('assignedKam')">{{ item?.assignedKam }}</td>
                                  <td *ngIf="hasRole('ROLE_VENDOR') && isColumnVisible('procurementPrice')">{{ item?.procurementPrice | number:'1.0-0':'en-IN' }}</td>
                                  <td *ngIf="hasRole('ROLE_VENDOR') && isColumnVisible('bidAmount')">{{ item?.bidAmount | number:'1.0-0':'en-IN' }}</td>
                                  <td *ngIf="isColumnVisible('summary') && notRole('ROLE_VENDOR')">
                                    <div class="summary-status-list">
                                      <div class="summary-status-item" *ngFor="let sm of getSummaryStatus(item?.orderStatus)">
                                        <span class="status-label">
                                          {{ formatStatus(sm.statusType) }}
                                        </span>
                                  
                                        <span
                                          class="status-pill"
                                          [ngClass]="getStatusClass(sm.status)">
                                          {{ formatStatus(sm.status) }}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="action-table-data">
                                    <div class="edit-delete-action">
                                      <ng-container>
                                          <!-- <a class="btn btn-primary me-2 p-2" *ngIf="(item.status === 'QUOTE_PENDING' || item.status === 'CREATED') && hasRole('ROLE_KAM')" href="javascript:void(0)" (click)="editOrderRow(item)">
                                              Edit
                                            </a> -->
                                            <a class="btn btn-primary me-2 p-2" *ngIf="activeQuickFilter === 'PENDING_ACTION' && hasRole('ROLE_KAM')" (click)="viewOrderHistory(item.id)">
                                              Take Action
                                          </a>
                                            <a class="btn btn-primary me-2 p-2" *ngIf="(item.status === 'HEAD_PENDING') && hasRole('ROLE_PROCUREMENT_HEAD')" (click)="viewOrderHistory(item.id)">
                                                Proceed
                                            </a>
                                            <span class="me-2 p-2" pTooltip="Edit" tooltipPosition="left" *ngIf="((item.status === 'QUOTE_PENDING' || item.status === 'CREATED' || item.status === 'DRAFT') && item.biddingEnable === 0) && hasRole('ROLE_KAM')" (click)="editOrderRow(item)">
                                                <svg width="16"  height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                            </span>
                                            <a class="btn btn-primary me-2 p-2" *ngIf="(item.status === 'ORDER_CONFIRMED')" (click)="startTrip(item)">
                                                <span *ngIf="checkTripStatus(item,'PENDING')">Create</span> Trip <span *ngIf="!checkTripStatus(item,'PENDING')">Detail</span>
                                            </a>
                                            <a
                                                class="btn btn-primary me-2 p-2"
                                                *ngIf="
                                                    checkTripStatus(item,'TRIP_INPROGRESS') ||
                                                    checkTripStatus(item,'TRIP_ENDED')
                                                "
                                                (click)="endTrip(item)">

                                                <!-- Trip in Progress -->
                                                <span *ngIf="checkTripStatus(item,'TRIP_INPROGRESS')">
                                                    End Trip
                                                </span>

                                                <!-- Trip Ended + Soft POD Pending -->
                                                <span *ngIf="
                                                    checkTripStatus(item,'TRIP_ENDED') &&
                                                    !checkSoftPod(item,'RECEIVED')
                                                ">
                                                    End Trip
                                                </span>

                                                <!-- Trip Ended + Soft POD Received + Hard POD Pending -->
                                                <span *ngIf="
                                                    checkTripStatus(item,'TRIP_ENDED') &&
                                                    checkSoftPod(item,'RECEIVED') &&
                                                    checkHardPod(item,'PENDING')
                                                ">
                                                    Add POD
                                                </span>

                                                <!-- Trip Ended + Hard POD Received || Lost -->
                                                <span *ngIf="
                                                    checkTripStatus(item,'TRIP_ENDED') &&
                                                    checkHardPod(item,'RECEIVED') || checkHardPod(item,'LOST')
                                                ">
                                                    Show POD
                                                </span>

                                                </a>
                                            <a *ngIf="hasRole('ROLE_PROCUREMENT') && (item.status === 'QUOTE_PENDING' || item.status === 'CREATED')" class="btn btn-primary me-2 p-2" href="javascript:void(0)" (click)="openSubmitRate(item)">
                                                Submit Rate
                                            </a>
                                            <a *ngIf="hasRole('ROLE_PROCUREMENT') && item.biddingEnable === 1 && item.status !== 'ORDER_CONFIRMED'" class="btn btn-primary me-2 p-2" href="javascript:void(0)" (click)="openViewBidding(item)">
                                                View Bidding
                                            </a>
                                        </ng-container>
                                        <ng-container *ngIf="hasRole('ROLE_VENDOR') && item.status === 'PendingOnVendor'">
                                          <a class="btn btn-accept me-2 p-2" href="javascript:void(0)" (click)="openBiddingConfirmation('AcceptedByVendor', item)">
                                              <!-- <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><defs><style> .cls-1 { fill: #650000; fill-rule: evenodd; } </style></defs><path class="cls-1" d="M800,510a30,30,0,1,1,30-30A30,30,0,0,1,800,510Zm-16.986-23.235a3.484,3.484,0,0,1,0-4.9l1.766-1.756a3.185,3.185,0,0,1,4.574.051l3.12,3.237a1.592,1.592,0,0,0,2.311,0l15.9-16.39a3.187,3.187,0,0,1,4.6-.027L817,468.714a3.482,3.482,0,0,1,0,4.846l-21.109,21.451a3.185,3.185,0,0,1-4.552.03Z" id="check" transform="translate(-770 -450)"></path></g></svg> -->
                                              ✓ Accept
                                          </a>
                                          <a class="btn btn-amber me-2 p-2" href="javascript:void(0)" *ngIf="item.counterNumber < 3" (click)="openBiddingDialog(item)">
                                            <!-- <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  width="20" height="20" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect x="330.25" y="129.857" style="fill:#FFE6B8;" width="121.095" height="176.824"></rect> <g> <path style="fill:#D35B38;" d="M454.327,93.624H327.269c-10.006,0-18.118,8.111-18.118,18.118l0,0 c0,10.006,8.111,18.118,18.118,18.118h127.058c10.006,0,18.118-8.111,18.118-18.118l0,0 C472.444,101.736,464.333,93.624,454.327,93.624z"></path> <path style="fill:#D35B38;" d="M454.327,306.685H327.269c-10.006,0-18.118,7.883-18.118,17.889l0,0 c0,10.006,8.111,18.118,18.118,18.118h127.058c10.006,0,18.118-8.111,18.118-18.118l0,0 C472.444,314.568,464.333,306.685,454.327,306.685z"></path> </g> <path style="fill:#FFAD61;" d="M465.972,382.37H315.624c-19.787,0-35.829,16.041-35.829,35.829l0,0c0,0.099,0.08,0.178,0.178,0.178 h221.65c0.099,0,0.178-0.08,0.178-0.178l0,0C501.801,398.411,485.76,382.37,465.972,382.37z"></path> <rect x="210.991" y="201.873" style="fill:#FFE6B8;" width="119.259" height="32.801"></rect> <path style="fill:#D35B38;" d="M210.991,243.845H35.772c-14.124,0-25.572-11.449-25.572-25.571l0,0 c0-14.123,11.449-25.572,25.572-25.572h175.219V243.845z"></path> <g> <path style="fill:#4D3D36;" d="M465.972,372.17H315.624c-25.38,0-46.028,20.648-46.028,46.028c0,5.722,4.655,10.378,10.378,10.378 h221.65c5.722,0,10.378-4.655,10.378-10.378C512,392.819,491.352,372.17,465.972,372.17z M292.034,408.178 c3.909-9.167,13.011-15.609,23.59-15.609h150.349c10.579,0,19.68,6.441,23.589,15.609H292.034z"></path> <path style="fill:#4D3D36;" d="M320.051,244.871v52.543c-12.129,3.174-21.1,14.146-21.1,27.16 c0,15.614,12.703,28.317,28.317,28.317h127.058c15.615,0,28.318-12.703,28.318-28.317c0-13.014-8.971-23.986-21.1-27.16v-158.29 c12.129-3.199,21.1-14.262,21.1-27.382c0-15.615-12.703-28.318-28.318-28.318H327.269c-15.614,0-28.317,12.703-28.317,28.318 c0,13.12,8.971,24.182,21.1,27.382v52.551h-98.913c-0.515-5.151-4.861-9.173-10.147-9.173H35.772 C16.046,182.503,0,198.549,0,218.274s16.046,35.771,35.772,35.771h175.219c5.286,0,9.633-4.023,10.147-9.173H320.051z M340.449,140.06h100.696v156.426H340.449V140.06z M454.327,316.885c4.441,0,7.92,3.378,7.92,7.69c0,4.366-3.552,7.919-7.92,7.919 H327.269c-4.366,0-7.919-3.551-7.919-7.919c0-4.313,3.479-7.69,7.919-7.69H454.327z M327.269,119.662 c-4.366,0-7.919-3.552-7.919-7.92s3.552-7.92,7.919-7.92h127.058c4.366,0,7.92,3.552,7.92,7.92s-3.552,7.92-7.92,7.92H327.269z M320.051,224.473H221.19v-12.398h98.861V224.473z M20.398,218.274c0-8.477,6.897-15.372,15.373-15.372h165.02v30.745H35.772 C27.295,233.646,20.398,226.749,20.398,218.274z"></path> <path style="fill:#4D3D36;" d="M421.227,286.598c5.633,0,10.199-4.567,10.199-10.199v-60.175c0-5.632-4.566-10.199-10.199-10.199 s-10.199,4.567-10.199,10.199v60.175C411.028,282.031,415.594,286.598,421.227,286.598z"></path> <path style="fill:#4D3D36;" d="M421.227,197.865c5.633,0,10.199-4.567,10.199-10.199v-3.06c0-5.632-4.566-10.199-10.199-10.199 s-10.199,4.567-10.199,10.199v3.06C411.028,193.298,415.594,197.865,421.227,197.865z"></path> </g> </g></svg> -->
                                            🏷️ Bidding
                                          </a>
                                          <a class="btn btn-reject me-2 p-2" href="javascript:void(0)" (click)="openBiddingConfirmation('RejectedByVendor', item)">
                                              ✕ Reject
                                          </a>
                                        </ng-container>
                                        <ng-container *ngIf="hasRole('ROLE_VENDOR')">
                                            <a class="btn btn-primary" href="javascript:void(0)" (click)="openTranscation(item)">
                                                View Transaction
                                            </a>
                                        </ng-container>
                                    </div>
                                  </td>
                                </tr>
                              </ng-template>
                          
                              <ng-template pTemplate="emptymessage">
                                <tr>
                                  <td colspan="14" rowspan="5" style="color: red; padding: 30px;">Not found.</td>
                                </tr>
                              </ng-template>
                            </p-table>
                          </div>


                    </div>
                    <app-pagination [totalCount]="totalCount" [pageSize]="pageSize" [currentPage]="currentPage"
                        (pageChange)="paginate($event)"></app-pagination>

                </div>
            </div>
        </div>
    </div>
</div>



<!-- ═══════════════════════════════════════════════
     SUBMIT RATE 
════════════════════════════════════════════════ -->
<p-dialog
  [(visible)]="showSubmitRateDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '30vw' }"
  styleClass="submit-rate-dialog"
  (onHide)="closeSubmitRateDialog()">
 
  <!-- Dialog header -->
  <ng-template pTemplate="header">
    <div>
      <div style="font-weight: 600; font-size: 1rem;">Submit rate</div>
      <div style="font-size: 0.8rem; color: #888; margin-top: 2px;">{{ currentOrderForRate?.orderNumber }}</div>
    </div>
  </ng-template>
 
  <div *ngIf="submitRateStep === 'confirm'" class="confirm-step">
    <div class="radar-icon">
       <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.001 512.001" xml:space="preserve" width="50" height="50" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect x="330.25" y="129.857" style="fill:#FFE6B8;" width="121.095" height="176.824"></rect> <g> <path style="fill:#D35B38;" d="M454.327,93.624H327.269c-10.006,0-18.118,8.111-18.118,18.118l0,0 c0,10.006,8.111,18.118,18.118,18.118h127.058c10.006,0,18.118-8.111,18.118-18.118l0,0 C472.444,101.736,464.333,93.624,454.327,93.624z"></path> <path style="fill:#D35B38;" d="M454.327,306.685H327.269c-10.006,0-18.118,7.883-18.118,17.889l0,0 c0,10.006,8.111,18.118,18.118,18.118h127.058c10.006,0,18.118-8.111,18.118-18.118l0,0 C472.444,314.568,464.333,306.685,454.327,306.685z"></path> </g> <path style="fill:#FFAD61;" d="M465.972,382.37H315.624c-19.787,0-35.829,16.041-35.829,35.829l0,0c0,0.099,0.08,0.178,0.178,0.178 h221.65c0.099,0,0.178-0.08,0.178-0.178l0,0C501.801,398.411,485.76,382.37,465.972,382.37z"></path> <rect x="210.991" y="201.873" style="fill:#FFE6B8;" width="119.259" height="32.801"></rect> <path style="fill:#D35B38;" d="M210.991,243.845H35.772c-14.124,0-25.572-11.449-25.572-25.571l0,0 c0-14.123,11.449-25.572,25.572-25.572h175.219V243.845z"></path> <g> <path style="fill:#4D3D36;" d="M465.972,372.17H315.624c-25.38,0-46.028,20.648-46.028,46.028c0,5.722,4.655,10.378,10.378,10.378 h221.65c5.722,0,10.378-4.655,10.378-10.378C512,392.819,491.352,372.17,465.972,372.17z M292.034,408.178 c3.909-9.167,13.011-15.609,23.59-15.609h150.349c10.579,0,19.68,6.441,23.589,15.609H292.034z"></path> <path style="fill:#4D3D36;" d="M320.051,244.871v52.543c-12.129,3.174-21.1,14.146-21.1,27.16 c0,15.614,12.703,28.317,28.317,28.317h127.058c15.615,0,28.318-12.703,28.318-28.317c0-13.014-8.971-23.986-21.1-27.16v-158.29 c12.129-3.199,21.1-14.262,21.1-27.382c0-15.615-12.703-28.318-28.318-28.318H327.269c-15.614,0-28.317,12.703-28.317,28.318 c0,13.12,8.971,24.182,21.1,27.382v52.551h-98.913c-0.515-5.151-4.861-9.173-10.147-9.173H35.772 C16.046,182.503,0,198.549,0,218.274s16.046,35.771,35.772,35.771h175.219c5.286,0,9.633-4.023,10.147-9.173H320.051z M340.449,140.06h100.696v156.426H340.449V140.06z M454.327,316.885c4.441,0,7.92,3.378,7.92,7.69c0,4.366-3.552,7.919-7.92,7.919 H327.269c-4.366,0-7.919-3.551-7.919-7.919c0-4.313,3.479-7.69,7.919-7.69H454.327z M327.269,119.662 c-4.366,0-7.919-3.552-7.919-7.92s3.552-7.92,7.919-7.92h127.058c4.366,0,7.92,3.552,7.92,7.92s-3.552,7.92-7.92,7.92H327.269z M320.051,224.473H221.19v-12.398h98.861V224.473z M20.398,218.274c0-8.477,6.897-15.372,15.373-15.372h165.02v30.745H35.772 C27.295,233.646,20.398,226.749,20.398,218.274z"></path> <path style="fill:#4D3D36;" d="M421.227,286.598c5.633,0,10.199-4.567,10.199-10.199v-60.175c0-5.632-4.566-10.199-10.199-10.199 s-10.199,4.567-10.199,10.199v60.175C411.028,282.031,415.594,286.598,421.227,286.598z"></path> <path style="fill:#4D3D36;" d="M421.227,197.865c5.633,0,10.199-4.567,10.199-10.199v-3.06c0-5.632-4.566-10.199-10.199-10.199 s-10.199,4.567-10.199,10.199v3.06C411.028,193.298,415.594,197.865,421.227,197.865z"></path> </g> </g></svg>
    </div>
    <h5 class="confirm-title">Initiate vendor bidding?</h5>
    <p class="confirm-subtitle">
      Would you like to invite vendors to bid on this order before submitting your rate?
    </p>
    <button type="button" class="btn btn-primary btn-block" (click)="onYesInvite()">
      Invite vendors
    </button>
    <button type="button" class="btn btn-cancel btn-block mt-2" (click)="onNoJustSubmit()">
      Submit rate
    </button>
  </div>
 
  <!-- ── Rate + Vendor form ── -->
  <div *ngIf="submitRateStep === 'form'" [formGroup]="rateForm">
 
    <!-- Rate -->
    <div class="mb-3">
      <label class="form-label">Your rate (₹) <span style="color:red">*</span></label>
      <input
        type="text"
        appIndianNumberFormat
        class="form-control"
        placeholder="Enter amount"
        formControlName="rate" />
      <small class="text-danger" *ngIf="isRateInvalid('rate')">Rate is required</small>
    </div>
 
    <!-- Vendors -->
    <div class="mb-3">
      <label class="form-label">Select vendors <span style="color:red">*</span></label>
 
      <!-- Multiple when inviteVendors = true -->
      <ng-select
        *ngIf="inviteVendors"
        [items]="vendorList"
        bindLabel="vendorName"
        bindValue="id"
        [multiple]="true"
        [closeOnSelect]="false"
        appendTo="body"
        placeholder="Search vendors..."
        formControlName="vendors">

        <!-- Select All header -->
        <ng-template ng-header-tmp>
            <div style="padding: 8px 12px; border-bottom: 1px solid #eee; display: flex; align-items: center; gap: 8px; cursor: pointer;"
            (click)="toggleSelectAll()">
            <input
                type="checkbox"
                [checked]="isAllSelected()"
                [indeterminate]="isSomeSelected()"
                style="width: 15px; height: 15px; cursor: pointer;"
                (click)="$event.stopPropagation();toggleSelectAll()" />
            <span style="font-size: 0.88rem; font-weight: 500; color: #374151;">Select all</span>
            </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
            <div>
            <div style="font-weight: 500; font-size: 0.9rem;">{{ item.vendorName }}</div>
            <div style="font-size: 0.78rem; color: #888;">{{ item.email }}</div>
            </div>
        </ng-template>
        </ng-select>
 
      <!-- Single when inviteVendors = false -->
      <ng-select
        *ngIf="!inviteVendors"
        [items]="vendorList"
        bindLabel="vendorName"
        bindValue="id"
        [multiple]="false"
        appendTo="body"
        placeholder="Search vendors..."
        formControlName="vendors">
        <ng-template ng-option-tmp let-item="item">
            <div>
              <div style="font-weight: 500; font-size: 0.9rem; display:flex; align-items:center; gap:6px;">
                {{ item.vendorName }}
                <span *ngIf="alreadyInvitedVendorIds.includes(item.id)"
                      class="badge badge-grey" style="font-size:0.65rem;">Already sent</span>
              </div>
              <div style="font-size: 0.78rem; color: #888;">{{ item.email }}</div>
            </div>
          </ng-template>
      </ng-select>
      <small class="text-danger" *ngIf="isRateInvalid('vendors')">Please select at least one vendor</small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <ng-container *ngIf="submitRateStep === 'confirm'"></ng-container>
    <div *ngIf="submitRateStep === 'form'" class="d-flex justify-content-between w-100">
      <button type="button" class="btn btn-cancel" (click)="onRateBack()">
        ‹ Back
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="rateForm.invalid"
        (click)="onSubmitRate()">
        <span *ngIf="inviteVendors">Send &amp; initiate bidding</span>
        <span *ngIf="!inviteVendors">Submit rate</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
<p-dialog
  [(visible)]="showBiddingDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '30vw' }"
  styleClass="bidding-rate-dialog"
  (onHide)="closeBiddingDialog()">

  <ng-template pTemplate="header">
    <div class="brd-header">
      <span class="brd-tag">🏷️ RATE COMPARISON</span>
      <div class="brd-vendor">{{ currentBiddingOrder?.vendorName || 'Vendor' }}</div>
    </div>
  </ng-template>

  <div class="brd-body" [formGroup]="biddingForm">

    <div class="brd-cols">

      <!-- Left: Procurement (read-only) -->
      <div class="brd-col">
        <div class="brd-col-header brd-customer-header">
          <span class="brd-col-icon">🏢</span>
          <div>
            <div class="brd-col-title">Procurement</div>
            <div class="brd-col-badge">🔒 read-only</div>
          </div>
        </div>

        <div class="brd-field">
          <label>PROCUREMENT PRICE</label>
          <div class="brd-amount-box brd-readonly">
            <span class="brd-currency">₹</span>
            <span class="brd-amount-val">{{ currentBiddingOrder?.procurementPrice || 0 | number }}</span>
          </div>
        </div>

        <div class="brd-field">
          <label>TRUCK COUNT</label>
          <div class="brd-amount-box brd-readonly">
            <span class="brd-amount-val">{{ currentBiddingOrder?.numberOfVehicle || 1 }}</span>
          </div>
        </div>
      </div>

      <!-- Right: Vendor Bid (editable) -->
      <div class="brd-col">
        <div class="brd-col-header brd-vendor-header">
          <span class="brd-col-icon">🚛</span>
          <div>
            <div class="brd-col-title">Vendor</div>
            <div class="brd-col-badge brd-editable-badge">✏️ editable</div>
          </div>
        </div>

        <div class="brd-field">
          <label>BID AMOUNT <span style="color:red">*</span></label>
          <div class="brd-amount-input-box">
            <span class="brd-currency">₹</span>
            <input
              type="text"
              appIndianNumberFormat
              class="brd-amount-input"
              placeholder="Enter amount"
              formControlName="bidAmount" />
          </div>
          <small class="brd-err" *ngIf="isBiddingInvalid('bidAmount')">
            Bid amount is required
          </small>
        </div>

        <div class="brd-field">
          <label>VEHICLES PROVIDED <span style="color:red">*</span></label>
          <div class="brd-amount-input-box">
            <input
              type="number"
              class="brd-amount-input"
              readonly
              placeholder="Enter vehicles"
              formControlName="vehicleProvided" />
          </div>
          <small class="brd-err" *ngIf="isBiddingInvalid('vehicleProvided')">
            Vehicle count is required
          </small>
        </div>
      </div>

    </div>

  </div>

  <ng-template pTemplate="footer">
    <div class="brd-footer">
      <button
        type="button"
        class="brd-btn brd-btn-bid"
        [disabled]="biddingForm.invalid || biddingLoading"
        (click)="openBiddingConfirmation('PendingOnCustomer')">
        🏷️ Submit Bid
      </button>
    </div>
  </ng-template>

</p-dialog>

<p-dialog
  [(visible)]="showBiddingConfirmDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '28vw' }"
  styleClass="submit-rate-dialog">

  <ng-template pTemplate="header">
    <div style="font-weight:600">
      Confirmation
    </div>
  </ng-template>

  <div class="confirm-step">

    <div class="radar-icon">
      <i class="pi pi-question-circle" style="font-size:32px"></i>
    </div>

    <h5 class="confirm-title">

      <ng-container [ngSwitch]="pendingBiddingStatus">

        <span *ngSwitchCase="'RejectedByVendor'">
          Are you sure you want to reject this order?
        </span>

        <span *ngSwitchCase="'AcceptedByVendor'">
          Are you sure you want to accept this order?
        </span>

        <span *ngSwitchCase="'PendingOnCustomer'">
          Are you sure you want to submit this bid?
        </span>

      </ng-container>

    </h5>

    <p class="confirm-subtitle">
      This action cannot be undone later.
    </p>

  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-between w-100">

      <button
        type="button"
        class="btn btn-cancel"
        (click)="cancelBiddingAction()">
        Cancel
      </button>

      <button
        type="button"
        class="btn btn-primary"
        (click)="confirmBiddingAction()">
        Confirm
      </button>

    </div>
  </ng-template>

</p-dialog>

<!-- ═══════════════════════════════════════════════
     TRANSACTION HISTORY DIALOG
════════════════════════════════════════════════ -->
<p-dialog
  [(visible)]="showTransactionDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '42vw' }"
  styleClass="history-dialog"
  (onHide)="closeTransactionDialog()">

  <ng-template pTemplate="header">
    <div class="history-header">
      <span class="history-icon">📜</span>
      <span class="history-title">Order Bidding History</span>
      <span class="history-vendor-tag" *ngIf="selectedBidForHistory?.orderNumber">
        {{ selectedBidForHistory?.orderNumber }}
      </span>
    </div>
  </ng-template>

  <div class="history-body">

    <div *ngIf="transactionLoading" class="loading-state">
      <i class="pi pi-spin pi-spinner"></i> Loading history...
    </div>

    <div *ngIf="!transactionLoading && historyTransactions.length === 0" class="empty-state">
      <i class="pi pi-history empty-icon"></i>
      <p>No bidding history yet</p>
    </div>

    <div class="history-table-wrap" *ngIf="!transactionLoading && historyTransactions.length > 0">
      <table class="history-table">
        <thead>
          <tr class="group-row">
            <th class="col-counter" rowspan="2">Counter</th>
            <th class="group-vendor" colspan="2"><span class="group-icon">🚛</span> Vendor</th>
            <th class="group-customer" colspan="2"><span class="group-icon">🏢</span> Procurement</th>
          </tr>
          <tr class="sub-row">
            <th class="col-vendor">No Of Vehicle</th>
            <th class="col-vendor">Price</th>
            <th class="col-customer">No Of Vehicle</th>
            <th class="col-customer">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let txn of historyTransactions; let i = index"
            class="history-row"
            [class.by-vendor]="txn?.biddingBy === 'VENDOR'"
            [class.by-customer]="txn?.biddingBy === 'CUSTOMER'">

            <td class="col-counter">
              <span class="counter-chip">
                Counter {{ txn?.counter ?? (i + 1) }}
                <i class="pi pi-arrow-up-right side-icon vendor-icon" *ngIf="txn?.biddingBy === 'VENDOR'" title="Vendor bid"></i>
                <i class="pi pi-arrow-up-right side-icon customer-icon" *ngIf="txn?.biddingBy === 'CUSTOMER'" title="Customer bid"></i>
              </span>
            </td>

            <td class="col-vendor" [class.active-cell]="txn?.biddingBy === 'VENDOR'">
              {{ txn?.vehicleProvide || '--' }}
            </td>
            <td class="col-vendor price-cell" [class.active-cell]="txn?.biddingBy === 'VENDOR'">
              <span *ngIf="txn?.vendorPrice">₹{{ txn?.vendorPrice | number }}</span>
              <span *ngIf="!txn?.vendorPrice" class="dash">--</span>
            </td>

            <td class="col-customer" [class.active-cell]="txn?.biddingBy === 'CUSTOMER'">
              {{ txn?.numberOfVehicle || '--' }}
            </td>
            <td class="col-customer price-cell" [class.active-cell]="txn?.biddingBy === 'CUSTOMER'">
              <span *ngIf="txn?.procurementPrice">₹{{ txn?.procurementPrice | number }}</span>
              <span *ngIf="!txn?.procurementPrice" class="dash">--</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</p-dialog>